import { PROTECTED_WALL_WALLKEY, PROTECTED_WALL_STATUS } from '../keys'
const initialState = { status: null, wallKey: null }
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case PROTECTED_WALL_WALLKEY: {
            return { ...state, wallKey: action.payload }
        }
        case PROTECTED_WALL_STATUS: {
            return { ...state, status: action.payload }
        }
        default:

            return { ...state }
    }

}